var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgIconArrowLeftLight = function SvgIconArrowLeftLight(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 9,
    viewBox: "0 0 6 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.78694 8.5C4.71821 8.5 4.64089 8.46794 4.58935 8.41984L0.585911 4.68437C0.534364 4.63627 0.5 4.56413 0.5 4.5C0.5 4.43587 0.534364 4.36373 0.585911 4.31563L4.58935 0.58016C4.64089 0.532064 4.71821 0.5 4.78694 0.5C4.85567 0.5 4.93299 0.532064 4.98454 0.58016L5.41409 0.980962C5.46564 1.02906 5.5 1.09319 5.5 1.16533C5.5 1.22946 5.46564 1.3016 5.41409 1.3497L2.0378 4.5L5.41409 7.6503C5.46564 7.6984 5.5 7.77054 5.5 7.83467C5.5 7.8988 5.46564 7.97094 5.41409 8.01904L4.98454 8.41984C4.93299 8.46794 4.85567 8.5 4.78694 8.5Z",
    fill: "#8E8E93"
  })));
};
export default SvgIconArrowLeftLight;